import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AuditInvitationDetail } from '@/common';

type DetailContextType = {
  data: AuditInvitationDetail;
  invalidate: () => void;
};

const DetailContext = createContext<DetailContextType | null>(null);

const useDetailContext = () => {
  const detailContext = useContext(DetailContext);

  if (!detailContext) {
    throw new Error('detailContext must be used within DetailProvider.');
  }

  return detailContext;
};

type DetailProviderProps = {
  data: AuditInvitationDetail;
} & PropsWithChildren;

const DetailProvider = ({ data, children }: DetailProviderProps) => {
  const queryClient = useQueryClient();

  const invalidate = () => {
    queryClient.invalidateQueries(['audit-inviatations-id', data.id]);
  };

  const value = useMemo<DetailContextType>(
    () => ({
      data,
      invalidate,
    }),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  return <DetailContext.Provider value={value}>{children}</DetailContext.Provider>;
};

export { DetailProvider, useDetailContext };
